import runtimeConfig from '~config/config';

// NU_EXPERIMENT: productSimilarityPdp
// https://urbnit.atlassian.net/browse/TYP-34099
/* remove below when the experiment is over */

export const ONLY_YMAL = 'only_ymal';
export const ONLY_VISUALLY_SIMILAR = 'only_visually_similar';
export const BOTH_VISUALLY_SIMILAR_AND_YMAL = 'both_visually_similar_and_ymal';

export const EXP_PRODUCT_SIMILARITY_PDP_VARIANT_MAP = {
    [ONLY_YMAL]: ONLY_YMAL,
    [ONLY_VISUALLY_SIMILAR]: ONLY_VISUALLY_SIMILAR,
    [BOTH_VISUALLY_SIMILAR_AND_YMAL]: BOTH_VISUALLY_SIMILAR_AND_YMAL,
};

export const YMAL_ENABLED_VALUES = [ONLY_YMAL, BOTH_VISUALLY_SIMILAR_AND_YMAL];
export const VISUALLY_SIMILAR_ENABLED_VALUES = [
    ONLY_VISUALLY_SIMILAR,
    BOTH_VISUALLY_SIMILAR_AND_YMAL,
];

export const getProductSimilarityPdp = () => {
    const { productSimilarityPdp } = runtimeConfig.features;

    return EXP_PRODUCT_SIMILARITY_PDP_VARIANT_MAP[productSimilarityPdp] ||
        EXP_PRODUCT_SIMILARITY_PDP_VARIANT_MAP.only_ymal;
};
